// Port of the `\Filter::search(TYPE_GAMES, owner, filter, RESULT_COLLECTION)`
// helper used by PHP `filter/core/search.php` when it needs a pre-pass over
// the same dataset (group-orphan identification, expansion count whitelist).
//
// PHP `Filter::search` hardcodes `cacheType = CACHE_INLINE` so any filter
// that is `_cache_require: [CACHE_COLLECTION]` (e.g. `config/nest.js`)
// short-circuits and doesn't fire inside the sub-search — otherwise the
// nest filter would contradict the `nestChild: true` / `nestParent: true`
// gate we set here.
//
// This JS port returns a filter class identical to GamesFilter except
// the cache type is CACHE_INLINE and the result type is RESULT_COLLECTION
// (we want collection_ids back, not game_ids).

import Filter from 'offline/filter/core/filter'
import F from 'offline/filter/constants'

var InlineSearch = Filter.extend({
	filter_type: F.TYPE_GAMES,
	cache_type: F.CACHE_INLINE,
	result_type: F.RESULT_COLLECTION,
	pseudo_type: F.PSEUDO_COLLECTION,
	json_package: 'collection',
	package_types: [F.PACKAGE_GAME, F.PACKAGE_COLLECTION]
})

export default InlineSearch
